export const Challenge_Criteria_DA = {
  // Toasts used for challenges
  challengeCriteria: {
    headline: "Hvordan beregnes din score?",
    fallguys: {
      headline: "Udregning af samlet score",
      criteria: {
        positionPoints: "Placering (Positions Point)",
        medalPoints: "SMP (Samlede Medalje Point)",
        rounds: "Runder",
        fame: "Fame",
        bronze: "Bronze medaljer (Top 50%)",
        silver: "Sølv medaljer (Top 20%)",
        gold: "Guld medaljer (1. plads)",
        total_badge_points: "Total badge points",
        finalPoints: "Final points",
      },
      description: {
        positionPoints: "Din placering i spillet.",
        medalPoints:
          "Først får du point per medalje du indsamler. Bronze medalje giver 1 point. Sølv medalje giver 2 point. Guld medalje giver 3 point. Disse point lægger vi sammen og kalder herefter 'SMP' (Samlede Medalje Point)",
        medalPointsGold: "Guld medalje giver 3 point.",
        medalPointsSilver: "Sølv medalje giver 2 point.",
        medalPointsBronze: "Bronze medalje giver 1 point.",
      },
    },
    fm: {
      bestLapTime: "omgangstid",
      distanceTravel: "Distance traveled",
      racePosition: "Race position",
    },
    cs: {
      kills: "Kills",
      assists: "Assists",
      deaths: "Deaths",
      overall_kd: "Overall K/D",
      averageKillStreak: "Gennefemsnitlig kill streak",
      highestKillStreak: "Højeste kill streak",
      totalKillHs: "Headshots",
      averageAmmoRequiredToKill: "Gennemsnitlig ammo brugt per kill",
      mvps: "MVPs",
      score: "Score",
      time: "Tid",
    },
    type: {
      fastest: "Hurtigst",
      least: "Færrest",
      slowest: "Langsomste",
      most: "Flest",
    },
  },
};
